export enum TextAffinity {
  upstream,
  downstream,
}
